import {DataTable, Tag} from '@/components/atoms'
import {TAG_COLOR} from '@/utils/constants/colors'

const IncludedCell = data => {
  return (
    <Tag
      color={data.row.original.included ? TAG_COLOR.RED_150 : TAG_COLOR.GREEN_150}
      text={data.row.original.included ? 'Exclude' : 'Include'}
      isCopyable={false}
    />
  )
}

const ReviewProductsTable = ({ products = [] }) => {
  const columns = [
    {columnKey: 'productName', header: 'Name'},
    {columnKey: 'productId', header: 'Product Id'},
    {columnKey: 'status', header: 'Status'},
    {columnKey: 'size', header: 'Size'},
    {columnKey: 'category', header: 'Category'},
    {columnKey: 'brand', header: 'Brand'},
    {
      columnKey: 'included',
      header: 'Include/Exclude',
      cellData: IncludedCell,
    },
  ]

  const hasData = products?.length > 0
  return (
    <div className="products-table">
      {hasData && (
        <DataTable
          pageIndex={1}
          pageSize={10}
          columns={columns}
          data={products}
          isDark
          showColumnFilters={false}
          selection="single"
        />
      )}
    </div>
  )
}

export default ReviewProductsTable
